export default __webpack_public_path__ + "static/media/diagnostics.40cd66f5.svg";